document.addEventListener( 'DOMContentLoaded', function() {
// PRODUCT IMAGE GALLERY SPLIDE SLIDER
  window.productGallerySplide = function() {
    var productGallerySplide = new Splide( '.product-gallery-splide',{rewind: true});
    productGallerySplide.mount();
  }

  window.productGallerySplide();
// END OF PRODUCT IMAGE GALLERY SPLIDE SLIDER
});